// extracted by mini-css-extract-plugin
module.exports = {"status":"Subscribe_status__1m37t","subscribe":"Subscribe_subscribe__3ghm_"};